import React from 'react';
import DataManagement from '../../components/datamanagement/DataManagement';

const DataManagementPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <DataManagement />
        </div>
    );
};

export default DataManagementPage;
